<template>
    <img v-if="Fso.objectType === FileSystemType.Folder && Fso.id === 0.1"
        class="icon"
        src="../../../public/icons/explorer/star.svg">
    <img v-else-if="Fso.objectType === FileSystemType.Folder"
        class="icon theme-svg"
        src="../../../public/icons/explorer/folder.svg">
    <img v-else-if="(Fso.objectType === FileSystemType.Process ||
        Fso.objectType === FileSystemType.InteractiveProcess)"
        class="icon_processV2 theme-svg"
        src="../../../public/icons/processV2.svg">
    <img v-else-if="Fso.objectType === FileSystemType.Form"
        class="icon theme-svg"
        src="../../../public/icons/explorer/excel.svg">
    <img v-else-if="Fso.objectType === FileSystemType.PowerBI"
        class="icon theme-svg"
        src="../../../public/icons/explorer/power_bi.svg">
    <img v-else-if="Fso.objectType === FileSystemType.Generic"
        class="icon theme-svg"
        src="../../../public/icons/explorer/generic.svg">
    <img v-else-if="Fso.objectType === FileSystemType.ReportBook"
        class="icon theme-svg"
        src="../../../public/icons/explorer/reportbook.svg">
    <img v-else-if="Fso.objectType === FileSystemType.XL3"
        class="icon theme-svg"
        src="../../../public/icons/explorer/xl3.svg">
    <img v-else-if="Fso.objectType === FileSystemType.CalcScript"
        class="icon theme-svg"
        src="../../../public/icons/explorer/calc_script.svg">
    <img v-else-if="Fso.objectType === FileSystemType.DocxReport"
        class="icon"
        src="../../../public/icons/explorer/word.svg">
    <img v-else-if="Fso.objectType === FileSystemType.PptxReport"
        class="icon"
        src="../../../public/icons/explorer/ppt.svg">
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import * as api from "@/api/ApiClient";
import {
    IAlmFileSystemObjectContent,
} from '@/components/pages/landscape/LandscapeManagementInterfaces';

export default defineComponent({
    data() {
        return {
            FileSystemType: api.FileSystemType
        }
    },
    props: {
        Fso: {
            type: Object as PropType<api.FileSystemObjectContent | IAlmFileSystemObjectContent>,
            required: true
        }
    },

})
</script>

<style scoped>
.icon {
    width: 24px;
    height: 24px;
}
.icon_processV2 {
    width: 17px;
    height: 24px;
    margin-left: 3px;
}
</style>